'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('components/index');

var _files = require('helpers/files');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _cloudConfig = require('../cloud-config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uploaderStyles = require('components/FineUploader/FineUploader.scss');

var CloudUploaderItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CloudUploaderItem, _Component);

  function CloudUploaderItem() {
    (0, _classCallCheck3.default)(this, CloudUploaderItem);
    return (0, _possibleConstructorReturn3.default)(this, (CloudUploaderItem.__proto__ || (0, _getPrototypeOf2.default)(CloudUploaderItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(CloudUploaderItem, [{
    key: 'uploaderThumbNode',
    value: function uploaderThumbNode() {
      var cloudFile = this.props.cloudFile;

      return (0, _files.getFileExtention)(cloudFile.name);
    }
  }, {
    key: 'fileExtNode',
    value: function fileExtNode() {
      var cloudFile = this.props.cloudFile;

      return (0, _files.getFileExtention)(cloudFile.name);
    }
  }, {
    key: 'fileNameNode',
    value: function fileNameNode() {
      var cloudFile = this.props.cloudFile;

      return cloudFile.name;
    }
  }, {
    key: 'uploadStatusNode',
    value: function uploadStatusNode() {
      var cloudFile = this.props.cloudFile;

      var serviceImg = _cloudConfig.assetsIcons[cloudFile.service];
      return _react2.default.createElement('img', { className: 'serviceImg', src: serviceImg, alt: '' });
    }
  }, {
    key: 'fileSizeNode',
    value: function fileSizeNode() {
      var cloudFile = this.props.cloudFile;

      return _react2.default.createElement(_index.FileSize, { size: cloudFile.size });
    }
  }, {
    key: 'progressBarNode',
    value: function progressBarNode() {
      var _classNames;

      var cloudFile = this.props.cloudFile;

      var progressClass = (0, _classnames2.default)(uploaderStyles.progress, (_classNames = {}, (0, _defineProperty3.default)(_classNames, uploaderStyles.isSuccess, cloudFile.status === 'success'), (0, _defineProperty3.default)(_classNames, uploaderStyles.isFailed, cloudFile.status === 'failed'), _classNames));

      var progressBarClass = (0, _classnames2.default)('progressBar', uploaderStyles.progressBar, uploaderStyles.file);
      return _react2.default.createElement(
        'div',
        { className: progressBarClass },
        _react2.default.createElement('s', { className: progressClass, style: { width: '100%' } })
      );
    }
  }, {
    key: 'uploadStatusIconNode',
    value: function uploadStatusIconNode() {
      var _props = this.props,
          deletable = _props.deletable,
          onDelete = _props.onDelete,
          cloudFile = _props.cloudFile;

      return _react2.default.createElement(_index.CloudUploadStatusIcon, {
        className: uploaderStyles.statusIcon,
        status: cloudFile.status,
        deletable: deletable,
        onDelete: onDelete
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          showOnSuccess = _props2.showOnSuccess,
          cloudFile = _props2.cloudFile;

      var hidden = !showOnSuccess && cloudFile.status === 'success';

      return _react2.default.createElement(_index.UniversalUploaderItem, {
        className: (0, _classnames2.default)(className, { hidden: hidden }),
        fileExtNode: this.fileExtNode(),
        fileNameNode: this.fileNameNode(),
        uploadStatusNode: this.uploadStatusNode(),
        fileSizeNode: this.fileSizeNode(),
        progressBarNode: this.progressBarNode(),
        uploadStatusIconNode: this.uploadStatusIconNode(),
        uploaderThumbNode: this.uploaderThumbNode()
      });
    }
  }]);
  return CloudUploaderItem;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  cloudFile: _propTypes2.default.object,
  deletable: _propTypes2.default.bool,
  onDelete: _propTypes2.default.func,
  showOnSuccess: _propTypes2.default.bool
}, _temp);
exports.default = CloudUploaderItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Cloud/CloudUploaderItem/CloudUploaderItem.js
// module id = 1972
// module chunks = 1